import { useEffect, useState } from 'react';
import {
  ToastWrapper,
  ToastIconSlot,
  ToastContent,
  ToastTitle,
  ToastMessage,
  ToastCloseButton,
  ToastCloseDivider,
  ToastCloseIcon,
} from './Toast.style';
import {
  ToastSuccessCutoutIcon,
  ToastErrorCutoutIcon,
  ToastWarningCutoutIcon,
  ToastInfoCutoutIcon,
} from './ToastCutoutIcons';
import { ToastProps } from './Toast.props';

export function Toast({ id, title, message, variant = 'success', duration = 5000, onClose }: ToastProps) {
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose(id);
    }, 300); // Tempo da animação de saída
  };

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration]);

  const renderIcon = () => {
    switch (variant) {
      case 'success':
        return <ToastSuccessCutoutIcon />;
      case 'error':
        return <ToastErrorCutoutIcon />;
      case 'warning':
        return <ToastWarningCutoutIcon />;
      case 'info':
        return <ToastInfoCutoutIcon />;
      default:
        return <ToastSuccessCutoutIcon />;
    }
  };

  return (
    <ToastWrapper $isExiting={isExiting} $variant={variant}>
      <ToastIconSlot>{renderIcon()}</ToastIconSlot>
      <ToastContent>
        <ToastTitle>{title}</ToastTitle>
        <ToastMessage>{message}</ToastMessage>
      </ToastContent>
      <ToastCloseDivider aria-hidden />
      <ToastCloseButton onClick={handleClose} aria-label="Fechar notificação">
        <ToastCloseIcon />
      </ToastCloseButton>
    </ToastWrapper>
  );
}
